<template>
    <div class="bg-grey-lightest">
        <section id="heading" class="pt-12 pb-24">
            <!-- Header Nav -->
            <header-nav ref="headerNav"></header-nav>
        </section>
        <section class="py-12">
            <div class="max-w-sm mx-auto px-6">
                <patient-loading v-if="! timeslot"></patient-loading>
                <div class="rounded bg-white shadow relative -mt-24" v-else>
                    <router-link v-if="! isBooked" :to="{ path: '/search', query: { type: timeslot.medicalPractice } }" class="text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2">
                        <span class="icon"><i class="mdi mdi-close"></i></span>
                    </router-link>
                    <router-link v-else :to="{ path: '/' }" class="text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2">
                        <span class="icon"><i class="mdi mdi-close"></i></span>
                    </router-link>
                    <div class="p-6 bg-teal text-white rounded-t" v-if="isBooked">
                        <span class="inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm" @click="showPartnerMessage = !showPartnerMessage">
                            <div>{{ $t('Appointment_confirmed') }}</div>
                        </span>
                        <div class="mt-4 text-sm">
                            {{ $t('You_have_booked_this_appointment_with_X_In_order_to_manage_it_you_will_be_redirecter_do_thier_website', { name: timeslot.partnerName }) }}
                        </div>
                    </div>
                    <div class="p-6 bg-orange text-white rounded-t" v-else>
                        <span class="inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm" @click="showPartnerMessage = !showPartnerMessage">
                            <div>{{ $t('Appointment_provided_by_X', { name: timeslot.partnerName }) }}</div>
                        </span>
                        <div class="mt-4 text-sm">
                            {{ $t('This_appointment_is_provided_by_our_partner_X', { name: timeslot.partnerName }) }}
                            {{ $t('Thus_you_will_be_redirected_to_their_website_in_order_to_book_it') }}
                        </div>
                    </div>
                    <div class="p-6">
                        <div class="mb-4">
                            <div class="text-blue text-sm font-semibold mb-1">{{ $t('When_') }}</div>
                            <div class="text-black font-semibold text-lg">{{ timeslot.dateTime | momentFormatTimestamp($t('date_selector_format') + ' [' + $t('at') + '] ' + $t('time_format')) }}</div>
                        </div>
                        <div class="mb-4 flex justify-between">
                            <div>
                                <div class="text-blue text-sm font-semibold mb-1">{{ $t('Who_will_treat_me_') }}</div>
                                <div class="text-grey-darkest">{{ timeslot.doctorFirstName + ' ' + timeslot.doctorLastName }}</div>
                                <div class="text-green font-semibold text-sm mt-1" v-if="timeslot.isDoctorRegulated && (timeslot.medicalPractice !== 'OSTEOPATH' && timeslot.medicalPractice !== 'PSYCHOLOGIST')">{{ $t('Regulated_Doctor') }}</div>
                                <div class="text-red font-semibold text-sm mt-1" v-if="!timeslot.isDoctorRegulated && (timeslot.medicalPractice !== 'OSTEOPATH' && timeslot.medicalPractice !== 'PSYCHOLOGIST')">{{ $t('Contracted_doctor_negative') }}</div>
                            </div>
                            <partner-avatar :external-url="timeslot.doctorAvatar" class="ml-2 w-10 h-10"></partner-avatar>
                        </div>
                        <div class="">
                            <div class="text-blue text-sm font-semibold mb-1">{{ $t('Where_have_I_to_go_') }}</div>
                            <div class="text-grey-darkest">
                                {{ timeslot.officeStreetName }}<br />
                                {{ timeslot.officeZipCode }} {{ timeslot.officeLocality }}
                            </div>
                        </div>
                    </div>
                    <gmap-map
                        :center="{lat: timeslot.officeLatitude, lng: timeslot.officeLongitude }"
                        :zoom="13"
                        :options="{disableDefaultUI: true}"
                        style="height: 250px;"
                        class="w-full">
                            <gmap-marker
                                :position="{lat: timeslot.officeLatitude, lng: timeslot.officeLongitude }"></gmap-marker>
                        </gmap-map>
                    <div class="px-6 py-4" v-if="! isBooked">
                        <a v-if="userId" :href="timeslot.partnerUrl" target="_blank" @click.prevent="handleClick" class="inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3">{{ $t('Book_this_appointment_with_X', { partner: timeslot.partnerName }) }}</a>
                        <button v-else @click="showLogin" class="bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3">{{ $t('Sign_in_to_book_this_appointment') }}</button>
                    </div>
                    <div class="px-6 py-4 rounded-b" v-else>
                        <a :href="timeslot.partnerUrl" target="_blank" @click.prevent="handleClick" class="inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3">{{ $t('Manage_this_appointment_with_X', { partner: timeslot.partnerName }) }}</a>
                    </div>
                </div>
                <dfp-slot
                    v-if="timeslot"
                    path="/21865209613/Patients/PartnerTimeslotShow"
                    :size="[300,250]"
                    :id="`div-gpt-ad-partner-timeslot`"
                    :medical-practice="timeslot.medicalPractice"
                    class="mt-6" />
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import helpers from '@/mixins/helpers'

import HeaderNav from '@/components/Patient/HeaderNav'
import PartnerAvatar from '@/components/PartnerAvatar.vue'

export default {
    name: 'PartnerTimeslotShow',

    mixins: [helpers],

    components: {HeaderNav, PartnerAvatar},

    data () {
        return {
            isBooked: false,
            timeslot: null,
            showPartnerMessage: false
        }
    },

    mounted () {
        let medicalPractice = this.$route.query.medicalPractice

        if (medicalPractice) {
            this.fetchTimeslot()
        } else {
            this.fetchAppointment()
        }
    },

    methods: {
        showLogin () {
            this.$refs.headerNav.showLogin()
        },

        async handleClick () {
            if (this.isBooked) {
                await this.$ga.event({
                    eventCategory: 'PartnerAppointment',
                    eventAction: 'BookPartnerAppointment',
                    eventLabel: this.timeslot.partnerName
                })
            } else {
                await this.$ga.event({
                    eventCategory: 'PartnerTimeSlot',
                    eventAction: 'BookPartnerTimeSlot',
                    eventLabel: this.timeslot.partnerName
                })
            }

            window.open(this.timeslot.partnerUrl, '_blank')
        },

        fetchAppointment () {
            if (! this.userId) {
                this.$router.push('/')

                return false
            }

            let doctorId = this.$route.query.doctorId
            let dateTime = this.$route.query.dateTime
            let latitude = this.$route.query.latitude
            let longitude = this.$route.query.longitude
            let medicalPractice = this.$route.query.medicalPractice

            axios.get(process.env.CLOUD_FUNCTIONS_BASE_URI + '/getPartnerAppointments', {
                    params: {
                        userId: this.userId,
                        language: this.patientLanguage.shortCode
                    },
                    headers: {
                        'Content-Type':  'application/json',
                    }
                })
                .then((response) => {
                    let appointments = response.data.filter((appointment) => {
                        return appointment.dateTime === dateTime &&
                            appointment.doctorId === doctorId
                    })

                    if (appointments.length > 0) {
                        this.timeslot = appointments[0]
                        this.isBooked = true
                    } else {
                        // Timeslot does not exist
                        this.$router.push('/')
                    }
                })
                .catch(error => {
                    console.log('error', error)
                })
        },

        fetchTimeslot () {
            let doctorId = this.$route.query.doctorId
            let dateTime = this.$route.query.dateTime
            let latitude = this.$route.query.latitude
            let longitude = this.$route.query.longitude
            let medicalPractice = this.$route.query.medicalPractice

            axios.get(process.env.CLOUD_FUNCTIONS_BASE_URI + '/getPartnerTimeSlots', {
                params: {
                    userId: this.userId ? this.userId : 'XXXXXXXXXXXXXXXXXXXXXXXXXXXX',
                    medicalPractice: medicalPractice,
                    language: this.patientLanguage.shortCode,
                    latitude: latitude,
                    longitude: longitude,
                },
                headers: {
                    'Content-Type':  'application/json',
                }
            })
            .then((response) => {
                let timeslots = response.data.filter((timeslot) => {
                    return timeslot.dateTime === dateTime &&
                        timeslot.doctorId === doctorId
                })

                if (timeslots.length > 0) {
                    this.timeslot = timeslots[0]
                } else {
                    this.fetchAppointment()
                }
            })
            .catch(error => {
                this.fetchAppointment()
                console.log('error', error)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Patient/PartnerTimeslotShow.vue